import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScTopicsModal = styled.div`
  .topics-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;

    @media (${device.mobileS}) {
      grid-template-columns: 1fr;
    }
  }
`;
